import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

import {
  Row,
  SpinnerLoader,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { Accordion } from '@/modules/common/components/Accordion';
import { Money } from '@/modules/common/components/Money';
import { PerformanceDetails } from '@/modules/common/components/PerformanceDetails';

import {
  getPortfolioPerformanceDetails,
  getWealthPerformanceDetails,
  IDefaultProps,
  IPerformanceDetailResponse
} from '@/modules/wealth/services/investment';

interface Props {
  historyOverview: IDefaultProps[];
  updatedAt: string;
  portfolioId: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WealthPerformanceAccordions',
  props: {
    historyOverview: null,
    updatedAt: null,
    portfolioId: null
  },
  setup(__props: any) {

const { portfolioId } = __props as {
  historyOverview: IDefaultProps[];
  updatedAt: string;
  portfolioId: string;
}



const currentIndex = ref(-1);
const isLoading = ref(true);
const hasError = ref(false);
const summaryDetails = ref<IPerformanceDetailResponse | null>(null);

async function openPeriodHistory(index: number, isOpen: boolean, year: string) {
  if (isOpen) {
    currentIndex.value = index;
    await getPerformanceDetails(year);
  } else {
    currentIndex.value = -1;
  }
}

async function getPerformanceDetails(year: string) {
  if (portfolioId) {
    await fetchPortfolioPerformanceDetails(year);
    return;
  }
  await fetchWealthPerformanceDetails(year);
}

async function fetchPortfolioPerformanceDetails(year: string) {
  try {
    hasError.value = false;
    isLoading.value = true;

    summaryDetails.value = await getPortfolioPerformanceDetails(
      Number(year),
      portfolioId
    );
  } catch (error) {
    console.error(error);
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

async function fetchWealthPerformanceDetails(year: string) {
  try {
    hasError.value = false;
    isLoading.value = true;

    summaryDetails.value = await getWealthPerformanceDetails(year);
  } catch (error) {
    console.error(error);
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

return { __sfc: true,currentIndex, isLoading, hasError, summaryDetails, openPeriodHistory, getPerformanceDetails, fetchPortfolioPerformanceDetails, fetchWealthPerformanceDetails, Row, SpinnerLoader, HelperViewStatus, Accordion, Money, PerformanceDetails }
}

})